import { ImportEnum } from "../enums/Import";
import { INeo4j } from "../interfaces/Neo4j";
import { ViewFromServer } from "../interfaces/ViewFromServer";

export class Importer{
    constructor(public connection: INeo4j, public type:ImportEnum, public view?: ViewFromServer,
      public cypher?: string, public onModelLoaded?: (error?: Error) => void){}
}
